// extracted by mini-css-extract-plugin
module.exports = {"Container":"Input_Container__2XjAQ","Icon":"Input_Icon__3N8YI"};